import React, { Component } from "react";

import { HomeSlider, HomeTitle, FaqItem } from "../../Components/UI/UI";

import { getWeather, asyncgetWeather } from "../../Utility/Utility";
import Menu from "../../Components/Menu/Menu";
import Footer from "../../Components/Footer/Footer";

import "./ContactUs.css";
import "../innerPage.css";

class ContactUs extends Component {
  state = {
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
      const weather = response[0];
      // const instagramData = response[1];
      // if ( weather.length > 0 ) {

      this.setState({
        // instagramData: instagramData.posts,
        deadSeaWeather: weather.deadsea.temperature,
        jerusalemWeather: weather.jerusalem.temperature,
        telAvivWeather: weather.telaviv.temperature,
        waterTemp: weather.telaviv.water_temp,
      });

      // }
    });
  }

  render() {
    return (
      <div className="page align-center page-FAQ inner-page page-infoforpastors">
        <Menu />
        <HomeSlider
          waterTemp={this.state.waterTemp}
          telAvivWeather={this.state.telAvivWeather}
          jerusalemWeather={this.state.jerusalemWeather}
        />
        <div className="container">
          <HomeTitle>Contact Us</HomeTitle>
          <div className="clear"></div>

          <div className="contact-us-wrapper">
            <table>
              <tr>
                <th>New York – North East Region US</th>
                <td>Tel: 1-646-779-6764</td>
                <td>
                  {" "}
                  <a href="mailto:ChadM@goisrael.gov.il">
                    ChadM@goisrael.gov.il
                  </a>
                </td>
              </tr>
              <tr>
                <th>Los Angeles – Western Region US</th>
                <td>Tel: 1-323-658-7463</td>
                <td>
                  {" "}
                  <a href="mailto:Director-LA@goisrael.gov.il">
                    Director-LA@goisrael.gov.il
                  </a>
                </td>
              </tr>
              <tr>
                <th>Atlanta – Southern Region US</th>
                <td>Tel: 1-404-541-2770</td>
                <td>
                  {" "}
                  <a href="mailto:Director-Atlanta@goisrael.gov.il">
                    Director-Atlanta@goisrael.gov.il
                  </a>
                </td>
              </tr>
              <tr>
                <th>Chicago – Midwest Region US</th>
                <td>Tel: 1-312-803-7080</td>
                <td>
                  {" "}
                  <a href="mailto:JillD@goisrael.gov.il">
                    JillD@goisrael.gov.il
                  </a>
                </td>
              </tr>
              {/* <tr>
                <th>Canada</th>
                <td>Tel: 1-416-964-3784</td>
                <td>
                  {" "}
                  <a href="mailto:igtocanada@goisrael.goil">
                    igtocanada@goisrael.goil
                  </a>
                </td>
              </tr> */}
              {/* <tr>
                <th>London</th>
                <td>Tel: 4-207-299-1100</td>
                <td>
                  {" "}
                  <a href="mailto:Info-uk@goisrael.gov.il">
                    Info-uk@goisrael.gov.il
                  </a>
                </td>
              </tr> */}
              {/* <tr>
                <th>Nordic Countries</th>
                <td>Tel: 6-8239209</td>
                <td>
                  {" "}
                  <a href="mailto:director-se@goisrael.gov.il">
                    director-se@goisrael.gov.il
                  </a>
                </td>
              </tr> */}
              {/* <tr>
                <th>Netherlands</th>
                <td>Tel: 1-20-616-1948</td>
                <td>
                  {" "}
                  <a href="mailto:info-nl@goisrael.gov.il">
                    info-nl@goisrael.gov.il
                  </a>
                </td>
              </tr> */}
              {/* <tr>
                <th>India</th>
                <td>Tel: 91-22-6137 0700</td>
                <td>
                  {" "}
                  <a href="mailto:info-Israel@goisrael.gov.il">
                    info-Israel@goisrael.gov.il
                  </a>
                </td>
              </tr> */}
            </table>
          </div>
          <div className="clear"></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/Pages/ContactUs/ContactUs.js